'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var makeId = require('./makeId.js');

function makeHash(length) {
    return makeId.makeId(length, 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789').toLowerCase();
}

exports.makeHash = makeHash;
